export default __webpack_public_path__ + "static/media/Poppins-Italic.ce3fff31.ttf";